@if (event()) {
  <div class="flex flex-col justify-center px-4">
    @if (description()) {
      <!-- Header Section -->
      <app-shared-card [additionalClasses]="'mb-6 p-4'">
        <div class="flex items-start gap-2 mb-2">
          <app-badge [label]="getEventCategoryLabel(eventType, eventCategory())"
                     [tailwindColor]="getEventCategoryColor(eventCategory())"></app-badge>
        </div>
        <h1 class="text-xl font-semibold text-gray-900 mb-2">{{ event()!.title }}</h1>

        <!-- Expandable Description -->
        <div class="mb-4">
          @if (needsExpansion()) {
            <button
              (click)="toggleDescription()"
              class="w-full text-left grid grid-cols-[1fr_auto] gap-2 items-start p-2 -m-2 cursor-pointer"
            >
              <p class="text-gray-600 text-sm leading-relaxed" [innerHTML]="displayDescription() | enforceNewLine"></p>
              <div class="flex items-center justify-center text-sm text-gray-500 mt-1">
                <lucide-angular
                  [img]="isDescriptionExpanded() ? chevronUp : chevronDown"
                  size="16"
                  class="transition-transform duration-200"
                ></lucide-angular>
              </div>
            </button>
          } @else {
            <p class="text-gray-600 text-sm leading-relaxed" [innerHTML]="displayDescription() | enforceNewLine"></p>
          }
        </div>

      </app-shared-card>
    }

    <!-- Updates Card -->
    <app-updates
      [eventDocumentId]="eventDocumentId"
      [showExpandCollapse]="true"
      [compact]="true"
      [showCard]="true"
      [cardClasses]="'mb-6 p-4'"
      [style.display]="hasUpdates ? null : 'none'">
    </app-updates>

    <!-- Event Details -->
    <app-shared-card [additionalClasses]="'mb-6 p-4'">
      <div class="text-sm text-gray-600">
        <app-datetime-info-line [startDate]="event()!.startDate" [endDate]="event()!.endDate" />
      </div>
    </app-shared-card>

    <!-- Video Conference Link -->
    @if (!!event() && !!event().teamsMeetingUrl && event().teamsMeetingUrl !== "") {

      <div class="mb-4 w-full md:w-auto md:self-start">
        <button
          (click)="joinMeeting()"
          [disabled]="!joinButtonActivated()"
          class="block p-4 rounded-lg transition-colors bg-[#DFE6FF] w-full"
          [class.cursor-pointer]="joinButtonActivated()"
          [class.hover:opacity-80]="joinButtonActivated()"
          [class.cursor-not-allowed]="!joinButtonActivated()"
          [class.bg-gray-200]="!joinButtonActivated()"
        >
          <div class="flex items-center justify-center">
            <lucide-angular [img]="video" size="20" class="mr-3"
                            [class.text-black]="joinButtonActivated()"
                            [class.text-gray-400]="!joinButtonActivated()"></lucide-angular>
            <span class="font-medium"
                  [class.text-black]="joinButtonActivated()"
                  [class.text-gray-400]="!joinButtonActivated()">Videokonferenz beitreten</span>
          </div>
        </button>
      </div>
    }

    @if (!!event() && eventHasLinks(event()!)) {
      <app-shared-card [additionalClasses]="'mb-6 p-4'">
        <h1 class="text-xl font-semibold text-gray-900 mb-2">Links</h1>
        <ul class="list-disc pl-4">
          @for (link of getEventLinks(event()!); track link) {
            <li>
              <app-link-box
                class="mb-3"
                [title]="link.title"
                [url]="link.url"
                [icon]="link.icon"
                [small]="true">
              </app-link-box>
            </li>
          }
        </ul>
      </app-shared-card>
    }

  </div>
}
